
export const new_types = [
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΓΡΟΤΕΜΑΧΙΟ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
  "ΑΠΟΘΗΚΗ",
  "ΑΠΟΘΗΚΗ",
  "ΑΠΟΘΗΚΗ",
  "ΑΠΟΘΗΚΗ",
  "ΑΠΟΘΗΚΗ",
  "ΑΠΟΘΗΚΗ",
  "ΑΠΟΘΗΚΗ",
  "ΑΠΟΘΗΚΗ",
  "ΑΠΟΘΗΚΗ",
  "ΑΠΟΘΗΚΗ",
  "ΑΠΟΘΗΚΗ",
  "ΑΠΟΘΗΚΗ",
  "ΑΠΟΘΗΚΗ",
  "ΑΠΟΘΗΚΗ",
  "ΒΙΟΜΗΧΑΝΟΣΤΑΣΙΟ",
  "ΒΙΟΜΗΧΑΝΟΣΤΑΣΙΟ",
  "ΒΟΣΚΟΤΟΠΟΣ",
  "ΒΟΣΚΟΤΟΠΟΣ",
  "ΒΟΣΚΟΤΟΠΟΣ",
  "ΒΟΣΚΟΤΟΠΟΣ",
  "ΒΟΣΚΟΤΟΠΟΣ",
  "ΒΟΣΚΟΤΟΠΟΣ",
  "ΒΟΣΚΟΤΟΠΟΣ",
  "ΒΟΣΚΟΤΟΠΟΣ",
  "ΒΟΣΚΟΤΟΠΟΣ",
  "ΒΟΣΚΟΤΟΠΟΣ",
  "ΒΟΣΚΟΤΟΠΟΣ",
  "ΒΟΣΚΟΤΟΠΟΣ",
  "ΒΟΣΚΟΤΟΠΟΣ",
  "ΓΡΑΦΕΙΟ",
  "ΓΡΑΦΕΙΟ",
  "ΓΡΑΦΕΙΟ",
  "ΓΡΑΦΕΙΟ",
  "ΓΡΑΦΕΙΟ",
  "ΓΡΑΦΕΙΟ",
  "ΔΑΣΙΚΗ ΕΚΤΑΣΗ",
  "ΔΑΣΙΚΗ ΕΚΤΑΣΗ",
  "ΔΑΣΙΚΗ ΕΚΤΑΣΗ",
  "ΔΑΣΙΚΗ ΕΚΤΑΣΗ",
  "ΔΑΣΙΚΗ ΕΚΤΑΣΗ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝ ΣΥΜΠΛΗΡΩΘΗΚΕ ",
  "ΔΕΝΔΡΟΚΑΛΛΙΕΡΓΕΙΑ",
  "ΔΕΝΔΡΟΚΑΛΛΙΕΡΓΕΙΑ",
  "ΔΕΝΔΡΟΚΑΛΛΙΕΡΓΕΙΑ",
  "ΔΕΝΔΡΟΚΑΛΛΙΕΡΓΕΙΑ",
  "ΔΕΝΔΡΟΚΑΛΛΙΕΡΓΕΙΑ",
  "ΔΕΝΔΡΟΚΑΛΛΙΕΡΓΕΙΑ",
  "ΔΙΑΜΕΡΙΣΜΑ",
  "ΔΙΑΜΕΡΙΣΜΑ",
  "ΔΙΑΜΕΡΙΣΜΑ",
  "ΔΙΑΜΕΡΙΣΜΑ",
  "ΔΙΑΜΕΡΙΣΜΑ",
  "ΔΙΑΜΕΡΙΣΜΑ",
  "ΔΙΑΜΕΡΙΣΜΑ",
  "ΔΙΑΜΕΡΙΣΜΑ",
  "ΔΙΑΜΕΡΙΣΜΑ",
  "ΔΙΑΜΕΡΙΣΜΑ",
  "ΔΙΑΜΕΡΙΣΜΑ",
  "ΔΙΑΜΕΡΙΣΜΑ",
  "ΔΙΑΜΕΡΙΣΜΑ",
  "ΔΙΑΜΕΡΙΣΜΑ",
  "ΔΙΚΑΙΩΜΑ ΥΨΟΥΝ",
  "ΚΑΛΛΙΕΡΓΕΙΑ",
  "ΚΑΛΛΙΕΡΓΕΙΑ",
  "ΚΑΛΛΙΕΡΓΕΙΑ",
  "ΚΑΤΑΣΤΗΜΑ",
  "ΚΑΤΑΣΤΗΜΑ",
  "ΚΑΤΑΣΤΗΜΑ",
  "ΚΑΤΑΣΤΗΜΑ",
  "ΚΑΤΑΣΤΗΜΑ",
  "ΚΑΤΑΣΤΗΜΑ",
  "ΚΑΤΑΣΤΗΜΑ",
  "ΚΑΤΑΣΤΗΜΑ",
  "ΚΑΤΑΣΤΗΜΑ",
  "ΚΑΤΑΣΤΗΜΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΙΑ",
  "ΟΙΚΟΠΕΔΟ",
  "ΟΙΚΟΠΕΔΟ",
  "ΟΙΚΟΠΕΔΟ",
  "ΟΙΚΟΠΕΔΟ",
  "ΟΙΚΟΠΕΔΟ",
  "ΟΙΚΟΠΕΔΟ",
  "ΟΙΚΟΠΕΔΟ",
  "ΟΙΚΟΠΟΕΔΟ",
  "ΟΥΔΕΜΙΑ ΜΕΤΑΒΟΛΗ",
  "ΟΥΔΕΜΙΑ ΜΕΤΑΒΟΛΗ",
  "ΟΥΔΕΜΙΑ ΜΕΤΑΒΟΛΗ",
  "ΟΥΔΕΜΙΑ ΜΕΤΑΒΟΛΗ",
  "ΠΑΡΚΙΝΓΚ",
  "ΠΑΡΚΙΝΓΚ",
  "ΠΑΡΚΙΝΓΚ",
  "ΠΑΡΚΙΝΓΚ",
  "ΠΑΡΚΙΝΓΚ",
  "ΠΑΡΚΙΝΓΚ",
  "ΠΑΡΚΙΝΓΚ",
  "ΠΑΡΚΙΝΓΚ",
  "ΠΑΡΚΙΝΓΚ",
  "ΠΑΡΚΙΝΓΚ",
  "ΠΑΡΚΙΝΓΚ",
  "ΠΑΡΚΙΝΓΚ",
  "ΠΙΣΙΝΑ",
  "ΠΙΣΙΝΑ",
  "ΠΙΣΙΝΑ",
]
export const excisting_types = [
"Α",
"Αγοτεμάχιο &Αποθήκη",
"Αγρόκτημα",
"Αγρός",
"Αγροτεμάχια",
"ΑΓΡΟΤΕΜΑΧΙΟ",
"Αγροτεμάχιο",
"Αγροτεμάχιο - Βοσκότοπος",
"Αγροτεμάχιο (εκτός οικισμού)",
"Αγροτεμάχιο (επωλήθη έναντι 27.500 €)",
"Αγροτεμάχιο + άλλες περιπτώσεις",
"Αγροτεμάχιο + Αποθήκη",
"ΑΓΡΟΤΕΜΑΧΙΟΑΓΡΟΤΕΜΑΧΙΟ",
"Αγροτεμάχο",
"Αγροτεμάχοι",
"Αροτεμάχιο",
"ΑΛΛΕΣ ΠΕΡΙΠΤΩΣΕΙΣ",
"Άλλες περιπτώσεις (υπόγειο)",
"Άλλες περιπτώσεις(αέρας)",
"ΑΛΛΗ ΠΕΡΙΠΤΩΣΗ",
"ΑΛΛΟΣ ΒΟΗΘΗΤΙΚΟΣ ΧΩΡΟΣ",
"Αποθήκη, Κατάστημα, Άλλες περιπτώσεις",
"περιπτώσεις",
"Aποθήκη",
"Αγροτεμάχιο - Αποθήκη",
"Αγροτεμάχιο & Αποθήκ",
"Αγροτεμάχιο και Αποθήκη",
"ΑΠΟΘΗΚΗ",
"Αποθήκη και άλλες περιπτώσεις",
"Αποθήκη και Πάρκινγκ",
"Αποθήκη-Πάρκινγκ",
"Βιοτεχνική",
"Βοηθ. Χώροι",
"Βοηθητικοί χώροι",
"Οικόπεδο, Αποθήκη",
"Οικόπεδο/Αποθήκη",
"Υπόγειο",
"Βιομηχανοστάσιο",
"ΒΙΟΤΕΧΝΙΚΟ/BI OMHXANIKO ΚΤΙΡΙΟ",
"Αγροτεμάχιο + Βοσκοτόπος",
"Αγροτεμάχιο και Βοσκότοπος",
"ΒΟΣΚΟΤΟΠΟΣ",
"Βοσκότοπος - Άλλες περιπτώσεις",
"ΒΟΣΚΟΤΟΠΟΣ /",
"ΒΟΣΚΟΤΟΠΟΣ / ΧΕΡΣΕΕΣ ΜΗ",
"ΒΟΣΚΟΤΟΠΟΣ / ΧΕΡΣΕΕΣ ΜΗ ΚΑΛΛΙΕΡΓΗΣΙΜ",
"ΒΟΣΚΟΤΟΠΟΣ / ΧΕΡΣΕΕΣ ΜΗ ΚΑΛΛΙΕΡΓΗΣΙΜ ΕΣ ΕΚΤΑΣΕΙΣ",
"Βοσκότοπος + άλλες περιπτώσεις",
"Βοσκότοπος και άλλες περιπτώσεις",
"Βοσκότοπος και Δασική έκταση",
"ΧΕΡΣΕΕΣ ΜΗ ΚΑΛΛΙΕΡΓΗΣΙΜ ΕΣ ΕΚΤΑΣΕΙΣ",
"Ωοσκότοπος",
"Γαφείο",
"Γραφείο",
"Γραφείο",
"Επαγγελματικός χώρος",
"Η ΣΤΕΓΗ / ΚΑΤΑΣΤΗΜΑ",
"Κατάστημα-Γραφείο",
"Αγροτεμάχιο - Δασική Έκταση",
"Αγροτεμάχιο και Δασική έκταση",
"ΔΑΣΙΚΗ ΕΚΤΑΣΗ",
"Δασική περιοχή",
"ΕΣ ΕΚΤΑΣΕΙΣ",
"-",
"Δε συμπληρώθηκε από το βουλευτή",
"Δε συμπληρώθηκε απο το βουλευτή (Μόνο μεταβολές)",
"Δε συμπληρώθηκε από τον βουλευτή",
"Δεν έγινε καμία μεταβολή από προηγούμενη δήλωση",
"Δεν έχει συμπληρωθε'΄΄ι από το βουλευτή",
"Δεν έχει συμπληρωθεί",
"Δεν έχει συμπληρωθεί από τη Βουλευτή",
"Δεν έχει συμπληρωθεί από τη βουλευτίνα",
"Δεν έχει συμπληρωθεί από το βουλευτή",
"Δεν έχει συμπληρωθεί από τον βουλευτή",
"Δεν έχει συμπληρωθεί από τον Ευρωβουλευτή",
"Δεν έχουν συμπληρωθεί",
"Δεν έχουν συμπληρωθεί από το βουλευτή",
"Δεν συμπληρώθηκε",
"Δεν συμπληρώθηκε από τη βουλευτή",
"Δεν συμπληρώθηκε από την Βουλετίνα",
"Δεν συμπληρώθηκε από την Βουλευτήνα",
"Δεν συμπληρώθηκε από την βουλευτίνα",
"Δεν συμπληρώθηκε από τον βουλευτή",
"Δεν συμπληρώθηκε από τον βυλευτή",
"Τα υπόλοιπα ακίνητα δεν συμπληρώθηκαν",
"Άλλες περιπτώσεις (αμπέλι)",
"Άλλες περιπτώσεις (ελιές)",
"ΔΕΝΔΡΟΚΑΛΛΙ",
"ΔΕΝΔΡΟΚΑΛΛΙ ΕΡΓΕΙΑ",
"Δενδροκαλλιέργειες",
"Ελιές",
"Diam",
"Αγροτεμάχιο + Διαμέρισμα",
"ΔΙΑΜΕΡΙΣΜΑ",
"Διαμέρισμα",
"Διαμέρισμα - Υπόγειο",
"Διαμέρισμα (ημιτελές)",
"Διαμέρισμα + Aγροτεμάχιο",
"Διαμέρισμα + Αγροτεμάχιο",
"Διαμέρισμα + αποθήκη",
"Διαμέρισμα από κοινού με σύζυγο",
"Διαμέρισμα και Αποθήκη",
"Διαμέρισμα, Αποθήκη, Πάρκινγκ",
"Διαμέρσιμα",
"Ισόγειο",
"ΔΙΚΑΙΩΜΑ ΥΨΟΥΝ",
"ΕΡΓΕΙΑ",
"ΚΑΛΛΙΕΡΓΕΙΑ",
"ΚΑΛΛΙΕΡΓΗΣΙΜ ΕΣ ΕΚΤΑΣΕΙΣ",
"Kατάστημα",
"Αγροτεμάχιο-Κατάστημα",
"Αποθήκη-Κατάστημα",
"ΕΠΑΓΓΕΛΜΑΤΙΚ",
"ΕΠΑΓΓΕΛΜΑΤΙΚ Η ΣΤΕΓΗ /",
"ΕΠΑΓΓΕΛΜΑΤΙΚ Η ΣΤΕΓΗ / ΚΑΤΑΣΤΗΜΑ",
"ΚΑΤΑΣΤΗΜΑ",
"Κτάστημα",
"Ξενοδ.",
"Οικόπεδο + κατάστημα",
"Αγροτεμάχιο - Οικία",
"Αγροτεμάχιο & Οικία",
"Αγροτεμάχιο + Οικία",
"Αγροτεμάχιο, Οικία",
"Αγρτοτεμάχιο - Οικία",
"Ερειπωμένη Οικία",
"Ημιτελής Κατοικία",
"Ημιτελής Οικία",
"ΜΟΝΟΚΑΤΟΙΚΙ",
"ΜΟΝΟΚΑΤΟΙΚΙ Α",
"Μονοκατοικία",
"Οικεία",
"ΟΙΚΙΑ",
"Οικία - Αποθήκη - Άλλες περιπτώσεις",
"Οικία + Αγροτεμάχιο",
"Οικία + Αποθήκη",
"Οικία + Οικόπεδο",
"Οικία από κοινού με σύζυγο",
"Οικία και Αποθήκη",
"Οικία-Αγροτεμάχιο",
"Οικία-Αποθήκη",
"Οικία, Άλλες περιπτώσεις",
"Οικία, Αποθήκη",
"Οικόπεδο + Οικία",
"Οικόπεδο-Οικία",
"Οικόπεδο, Οικία",
"Οικία",
"Αγροτεμάχιο και Οικόπεδο",
"Οικόπεδο",
"Οικόπεδο",
"Οικόπεδο (Δικαίωμα Ύψουν)",
"Οικόπεδο (δικαίωμα υψους)",
"Οικόπεδο + Αποθήκη",
"Οικόπεδο από κοινού με τέκνο",
"Oικόπεδο",
"Ουδεμία αλλαγή",
"Ουδεμία Μεταβολή",
"Ουδεμία μεταβολή στα λοιπά ακίνητα",
"Ουδεμία μεταβολή στα υπόλοιπα ακίνητα",
"Αποθήκη - Πάρκινγκ",
"Αποθήκη & Πάρκινγκ",
"Αποθήκη και Πάρκιγνκ",
"Γκαράζ",
"ΘΕΣΗ",
"ΘΕΣΗ ΣΤΑΘΜΕΥΣΗΣ",
"Πάρκιγνκ",
"Πάρκινγ",
"Πάρκινγκ",
"Πάρκινγκ (5 θέσεις των 10 τμ εκάστη)",
"Πάρκινγκ (5 θέσεις των 10τμ εκάστη)",
"ΣΤΑΘΜΕΥΣΗΣ",
"Δεν είναι κατανοητό από την βουλευτή",
"Κήπος - Πισίνα",
"ΠΙΣΙΝΑ",
"0",
"Κατεστραμμένο αρχείο, τα στοιχεία δεν εμφανίζονται",
"Επιβατικό",
]
